import { useEffect, useState } from "react";
import { BackMobileIcon, CancelIcon, PlayButtonRed, TemplateAddButtonIcon, TickIcon } from "../../icon";
import { ChannelAccountModel, ChannelType } from "../../models/channels/channels.model";
import { mapToUser } from "../../models/conversations";
import SelectChannelComponent from "../conversations/select-channel.component";
import { DialogHeaders, ToasterTexts, buttonLabels } from "../shared/constants";
import { LoadChannelTemplates } from "../../actions";
import { ChannelUserModel, UserModel, mapToChannelUser } from "../../models/users.model";
import { ChannelTemplateButtonModel, FacebookButtonType, FacebookTemplateType, TemplateModel } from "../../models/templates.models";
import RichEditor from "../shared/richtext-editor/rich-text-editor.component";
import ButtonComponent from "../shared/button/button.component";
import Config from "../../config";
import { FileService } from "../../services/FileService";
import MessageComposer from '../conversations/message-composer';
import { validateForm } from "../shared/form-validation";
import { TemplateService } from "../../services/TemplateService";
import setToast from "../../helpers/toaster.helper";
import { ToasterType } from "../shared/toaster/toaster.model";
import { ChannelConversationService } from "../../services/channels/ChannelConversationService";
import { LiveChatService } from "../../services/channels/LiveChatService";
import { MediaType, MessageType } from "../../models/media.models";
import { UtilityService } from "../../services/UtilityService";
import { Autocomplete, Dialog, DialogActions, DialogContent, DialogTitle, FormHelperText, Grid, TextField, Tooltip } from "@mui/material";
import * as selector from '../../selectors/selectors';
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

let type = [{ Name: "Private", Value: true }, { Name: "Shared with everyone", Value: false }];

const initialValue = [
    {
        type: "paragraph",
        children: [{ text: "" }]
    }
];

interface IProps {
    Show: boolean;
    CloseTemplate: (flag: boolean) => void;
    Template?: any;
    SelectedPage: any;
    SelectedChannel: any;
}


const AddTemplateComponent = (props: IProps) => {
    const dispatch = useDispatch()
    const Channels: ChannelAccountModel[] = useSelector(selector.Channels)
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)

    const [channel, setChannel] = useState<number>(null)
    const FaceBooktemplateTypes = [
        { Name: "Button Template", Value: FacebookTemplateType.BUTTON_TEMPLATE },
        { Name: "Media Template", Value: FacebookTemplateType.MEDIA_TEMPLATE },
    ]

    const FaceBookButtonTypes = [
        { Name: "URL Button ", value: FacebookButtonType.URL_BUTTON }
    ]

    const [page, setPage] = useState<any>(Channels.find(x => x.ID === props?.Template?.ChannelAccountID))
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [openImages, setOpenImages] = useState<boolean>(false);
    const [media, setMedia] = useState<any>();
    const [templateType, settemplateType] = useState<any>(props.Template?.TemplateType === "media" ? FaceBooktemplateTypes[1] : props?.Template?.TemplateType === "button" ? FaceBooktemplateTypes[0] : null);
    const [buttonType, SetButtonType] = useState<any>(props.Template?.TemplateType === "button" ? FaceBookButtonTypes[0] : null);
    const [imageLinks, setImageLinks] = useState<{ Type: string, Url: string }[]>(props.Template?.Payload?.elements?.map(x => {
        return {
            Url: x.media_type
            , Type: x.url
        }
    }))
    const [buttons, setButtons] = useState<ChannelTemplateButtonModel[]>(
        props.Template?.Payload?.buttons?.map(x => {
            return {
                Id: new Date().valueOf(),
                ButtonName: x.title,
                ButtonError: "",
                Url: x.url,
                UrlError: "",
            }
        })
    )
    const [templateHeader, setTemplateHeader] = useState<typeof initialValue>(initialValue)

    const [template, setTemplate] = useState<TemplateModel>(
        !!props.Template?.ID ?
            {
                ID: props.Template.ID,
                Title: props.Template.Title,
                IsPrivate: props.Template.IsPrivate,
                CreatedByID: props.Template.CreatedByID,
                UpdatedDateTime: props.Template.UpdatedDateTime,
                Message: props.Template.Message,
                Media: { ID: "", Name: "", Url: props.Template?.Url, ContentType: props.Template?.MediaType }
            }
            :
            {
                ID: "",
                Title: "",
                IsPrivate: false,
                CreatedByID: "",
                UpdatedDateTime: "",
                Message: "",
                Media: null
            }
    )
    const [errors, setErrors] = useState<{
        Channel: string,
        Page: string,
        Title: string,
        TemplateType: string,
        ButtonType: string,
        TemplateHeader: string,
        MediaUrl: string,
        Message: string,
    }>({
        Channel: "",
        Page: "",
        Title: "",
        TemplateType: "",
        ButtonType: "",
        TemplateHeader: "",
        MediaUrl: "",
        Message: "",
    })


    const handleChannel = (value: number) => {
        setChannel(value)
        setPage(null)
        settemplateType(null)
        setTemplate({ ...template, Title: "", Message: "" })
        setErrors({ Channel: "", Page: "", Title: "", TemplateType: "", ButtonType: "", TemplateHeader: "", MediaUrl: "", Message: "", })
    }

    const handleTemplateHeaderPreview = (Header) => {

        let convertedBody = Header[0].children.map((x) => {
            let children = x.text
            if (x.bold) {
                children = <b>{children}</b>
            }

            if (x.strikethrough) {
                children = <s>{children}</s>
            }

            if (x.italic) {
                children = <i>{children}</i>
            }

            if (x.underline) {
                children = <u>{children}</u>
            }

            return children
        }
        )

        return <div>{convertedBody}</div>

    }

    const slateTostring = (header) => {

        let convertedHeaderPayload = header[0].children.map((x) => {
            let formattedText = x.text

            if (x.bold) {
                formattedText = `*${formattedText}*`;
            }
            if (x.italic) {
                formattedText = `_${formattedText}_`;
            }
            if (x.strikethrough) {
                formattedText = `~${formattedText}~`;
            }

            return formattedText
        }
        ).join("")

        return convertedHeaderPayload

    }

    const stringToSlate = (formattedText) => {
        const elements = [];
        let currentText = "";
        let bold = false;
        let italic = false;
        let strikethrough = false;

        if (formattedText) {

            for (let i = 0; i < formattedText.length; i++) {
                const char = formattedText[i];

                if (char === "*" && formattedText[i + 1] !== "*") {
                    if (currentText) {
                        elements.push({ text: currentText, bold: bold, italic: italic, strikethrough: strikethrough });
                        currentText = "";
                    }
                    bold = !bold;
                }

                else if (char === "_") {
                    if (currentText) {
                        elements.push({ text: currentText, bold: bold, italic: italic, strikethrough: strikethrough });
                        currentText = "";
                    }
                    italic = !italic;
                }

                else if (char === "~") {
                    if (currentText) {
                        elements.push({ text: currentText, bold: bold, italic: italic, strikethrough: strikethrough });
                        currentText = "";
                    }
                    strikethrough = !strikethrough;
                }

                else {
                    currentText += char;
                }
            }

            if (currentText) {
                elements.push({ text: currentText, bold: bold, italic: italic, strikethrough: strikethrough });
            }
        }
        else {
            elements.push({ text: currentText })
        }

        return [{ type: "paragraph", children: elements }];
    };

    const handlePage = (event, value) => {
        if (!value) {
            setErrors({ ...errors, Page: "Page canot be blank" })
        }
        else {
            setErrors({ ...errors, Page: "" })
        }
        setPage(value)
    }

    const handleTemplateTitle = (value) => {
        validateForm({ Title: value },
            (Errors) => {
                setErrors({ ...errors, ...Errors })
            })
        setTemplate({ ...template, Title: value })
    }

    // const handleMediaUrl = (value) => {
    //     setMedia(value)
    // }

    const handleHeader = (value) => {
        if (!value[0].children[0].text) {
            setErrors({ ...errors, TemplateHeader: "header canot be blank" })
        }
        else {
            setErrors({ ...errors, TemplateHeader: "" })
        }
        setTemplateHeader(value)
    }

    const handletemplateType = (event, value) => {
        if (!value) {
            setErrors({ ...errors, TemplateType: "Template Type canot be blank", TemplateHeader: "", ButtonType: "" })
        }
        else {
            setErrors({ ...errors, TemplateType: "", TemplateHeader: "", ButtonType: "", MediaUrl: "" })
        }
        settemplateType(value)
        setButtons([{
            Id: new Date().valueOf(),
            ButtonName: "",
            ButtonError: "",
            Url: "",
            UrlError: "",
        }])
        setMedia({ Type: "", Url: "" })
        SetButtonType(null)
        setTemplateHeader(initialValue)
    }

    const handleButtonType = (event, value) => {
        if (!value) {
            setErrors({ ...errors, ButtonType: "Button Type canot be blank" })
        }
        else {
            setErrors({ ...errors, ButtonType: "" })
        }
        SetButtonType(value)
        setButtons([{
            Id: new Date().valueOf(),
            ButtonName: "",
            ButtonError: "",
            Url: "",
            UrlError: "",
        }])
    }

    const handleButtonName = (value: any, id: number) => {
        setButtons(buttons.map(x => x.Id === id ? { ...x, ButtonName: value, ButtonError: value ? "" : "Button canot be blank" } : x))
    };

    const handleButtonUrl = (value: any, id: number) => {
        setButtons(buttons.map(x => x.Id === id ? { ...x, Url: value, UrlError: value ? UtilityService.isValidURL(value) ? "" : "Incorrect URL" : "Url canot be blank" } : x))
    };

    const handleRemoveButton = (id: number) => {
        setButtons(buttons.filter(x => x.Id !== id))
    }

    const handleAddButton = () => {
        setButtons([...buttons, {
            Id: new Date().valueOf(),
            ButtonName: "",
            ButtonError: "",
            Url: "",
            UrlError: "",
        }])
    }

    const handleUrlRoute = (url: string, buttonName: string) => {
        if (url.length && buttonName.length) {
            window.open(url, "_blank")
        }
    }

    const handleFacebookPhotos = () => {
        if (!page) {
            setToast("Please select a page to view images", ToasterType.DANGER)
        }
        else {
            ChannelConversationService.getPhotosFromFacebook(Channels.find(x => x.ID === page.ID).AccountId).then(res => {
                if (res.data.data.length) {
                    setMedia({ Type: "", Url: "" })
                    setImageLinks(res.data.data.map(x => { return { Url: x.preview_link, Type: x.type } }))
                    setOpenImages(true)
                }
                else {
                    setToast("there are no images in the page", ToasterType.DANGER)
                }
            }).catch(
                () => {
                }
            )
        }
    }

    const handleImageClick = (value) => {
        setMedia(value);
        setErrors({ ...errors, MediaUrl: "" })
    };

    const handleMessageChanges = (data: { body: string, media: any, bodyLength: number }) => {
        if ((!data.body && !data.media) || (data.body.length <= 0 && data.media.length <= 0)) {
            setTemplate({ ...template, Message: data.body, Media: data.media })
            setErrors({ ...errors, Message: "Message cannot be blank" })

        } else {
            setTemplate({ ...template, Message: data.body, Media: data.media })
            setErrors({ ...errors, Message: "" })
        }
        if (data.media?.ID === undefined && data.media && channel === ChannelType.SMS) {
            setMedia(data.media)
            const uploadFile = {
                File: data.media,
            }
            var formData = new FormData();
            formData.append("File", uploadFile.File);
            FileService.UploadNewFile(formData, uploadFile.File?.name, uploadFile.File?.type).then(res => {
                var result = res.data;
                setTemplate({ ...template, Media: { ContentType: result.contentType, ID: result.id, Name: result.name, Url: `${Config.API_URL}/api/File/${result.id}/view` } })
            })
        }
        else if (data.media) {
            setTemplate({ ...template, Media: data.media?.Url ? data.media?.Url : data.media, Message: data.body })
            setMedia(data.media)
        }
        else {
            setMedia(data.media === null && "")
            setTemplate({ ...template, Media: null, Message: data.body })
        }
    }

    const user = mapToChannelUser(JSON.parse(localStorage.getItem("current-user"))) as ChannelUserModel;

    const getMediaType = (type: string) => {
        if (type != null) {
            const mediatype = type.split('/')[0];
            switch (mediatype) {
                case MediaType.IMAGE:
                case MediaType.IMAGE_JPEG:
                case MediaType.IMAGE_ARW:
                case MediaType.IMAGE_PNG:
                case MediaType.IMAGE_GIF:
                case MediaType.IMAGE_WEBP:
                case MediaType.IMAGE_SVG:
                    return MessageType.IMAGE
                case MediaType.VIDEO:
                    return MessageType.VIDEO
                case MediaType.AUDIO:
                    return MessageType.AUDIO
                default:
                    return MessageType.FILE
            }
        }
    }

    const formSubmit = async (event: any) => {
        event.preventDefault();
        if ((channel === ChannelType.LIVE_CHAT || channel === ChannelType.GOOGLE_BUSINESS)) {
            const customValidator = (template.Media?.ID || media) ?
                validateForm({ Title: template.Title, Type: template.IsPrivate }, (Errors) => {
                    setErrors({ ...errors, ...Errors })
                })
                : validateForm({ Title: template.Title, Type: template.IsPrivate, Message: template.Message }, (Errors) => {
                    setErrors({ ...errors, ...Errors })
                })
            if (customValidator) {
                var Form_Data = new FormData();
                let extension = props.Template?.Url?.substring(props.Template?.Url.lastIndexOf(".") + 1) === "svg" ? "image/svg+xml" : props.Template?.MediaType;

                let file = new File([await ((await fetch(props.Template?.Url)).blob())], props.Template?.Filename, { type: extension });
                Form_Data.append("file", !!media ? (media?.Url?.includes("s3")) ? file : media : "");
                Form_Data.append("name", template.Title);
                Form_Data.append("text", template.Message);
                Form_Data.append("channel_account", page.ID);
                Form_Data.append("mmsType", getMediaType(!!media?.type ? media.type : (media?.Url?.includes("s3")) ? extension : ""));
                setIsLoading(true)
                props.Template?.ID ?
                    ChannelConversationService.editChannelTemplate(props.Template?.ID, channel, Form_Data)
                        .then(res => {
                            setToast(ToasterTexts.TEMPLATE_ADD_SUCCESS.replace('<Name>', template.Title), ToasterType.SUCCESS)
                            setIsLoading(false)
                            props.CloseTemplate(false)
                            LoadChannelTemplates(dispatch, user.OrganizationID)
                            setMedia("")
                        })
                        .catch(err => {
                            setToast(err.response.data, ToasterType.DANGER)
                            setIsLoading(false)
                            props.CloseTemplate(false)
                            setMedia("")
                        })
                    :
                    LiveChatService.addChannelTemplate(user.OrganizationID, channel, Form_Data)
                        .then(res => {
                            setToast(ToasterTexts.TEMPLATE_ADD_SUCCESS.replace('<Name>', template.Title), ToasterType.SUCCESS)
                            setIsLoading(false)
                            props.CloseTemplate(false)
                            LoadChannelTemplates(dispatch, user.OrganizationID)
                            setMedia("")
                        })
                        .catch(err => {
                            setToast(err.response.data, ToasterType.DANGER)
                            setIsLoading(false)
                            props.CloseTemplate(false)
                            setMedia("")
                        })
            }
        }

        if (channel === ChannelType.INSTAGRAM) {
            setToast(`Templates for "Instagram" yet to be created`, ToasterType.SUCCESS)
        }


        let validationErrors = {
            Channel: errors.Channel,
            Page: errors.Page,
            Title: errors.Title,
            TemplateType: errors.TemplateType,
            ButtonType: errors.ButtonType,
            TemplateHeader: errors.TemplateHeader,
            MediaUrl: errors.MediaUrl,
            Message: errors.Message,
        }
        let buttonErrors = false
        validationErrors = { ...validationErrors, Page: !page ? "Page canot be blank" : "", TemplateType: !templateType ? "Template Type canot be blank" : "" }
        validateForm({ Title: template.Title }, (Errors) => {
            validationErrors = { ...validationErrors, ...Errors }
        })
        if (templateType) {
            if (templateType.Value === FacebookTemplateType.BUTTON_TEMPLATE) {
                if (!templateHeader[0].children[0].text) {
                    validationErrors = ({ ...validationErrors, TemplateHeader: "header canot be blank" })
                }
                if (!buttonType) {
                    validationErrors = ({ ...validationErrors, ButtonType: "Button Type canot be blank" })
                }
            }
            if (templateType.Value === FacebookTemplateType.MEDIA_TEMPLATE) {
                if (!media.Url) {
                    validationErrors = ({ ...validationErrors, MediaUrl: "select atleast one media" })
                    setToast("Please select atleast one media element", ToasterType.DANGER)
                }
            }
            if (buttons.find(x => !x.ButtonName) || buttons.find(x => !x.Url)) {
                setButtons(buttons.map(x => ({ ...x, ButtonError: x.ButtonName ? "" : "Button canot be blank", UrlError: x.Url ? "" : "URL canot be blank" })))
                buttonErrors = true
            }
            if (Object.values(validationErrors).find(x => x !== "") || buttonErrors) {
                setErrors({ ...validationErrors })
                return
            }
            else {
                setIsLoading(true)
                let data = templateType.Value === FacebookTemplateType.BUTTON_TEMPLATE ? {
                    name: template.Title,
                    type: templateType.Value,
                    payload: {
                        template_type: "button",
                        text: slateTostring(templateHeader),
                        buttons: buttons.map(x => { return { type: "web_url", title: x.ButtonName, url: x.Url } })
                    },
                    channel_account: page.ID,
                }
                    :
                    templateType.Value === FacebookTemplateType.MEDIA_TEMPLATE &&
                    {
                        name: template.Title,
                        type: templateType.Value,
                        channel_account: page.ID,
                        payload: {
                            template_type: "media",
                            elements: [
                                {
                                    media_type: "image",
                                    url: media.Url
                                }
                            ],
                            buttons: buttons.map(x => { return { type: "web_url", title: x.ButtonName, url: x.Url } })
                        }
                    }
                props.Template?.ID ?
                    ChannelConversationService.editFacebookTemplate(props.Template?.ID, data).then(res => {
                        setToast(ToasterTexts.TEMPLATE_ADD_SUCCESS.replace('<Name>', template.Title), ToasterType.SUCCESS)
                        setIsLoading(false)
                        props.CloseTemplate(false)
                        LoadChannelTemplates(dispatch, user.OrganizationID)
                    }).catch(err => {
                        setToast(err.response.data, ToasterType.DANGER)
                        setIsLoading(false)
                        props.CloseTemplate(false)
                    })
                    :
                    ChannelConversationService.createFacebookTemplate(user.OrganizationID, channel, data).then(res => {
                        setToast(ToasterTexts.TEMPLATE_ADD_SUCCESS.replace('<Name>', template.Title), ToasterType.SUCCESS)
                        setIsLoading(false)
                        props.CloseTemplate(false)
                        LoadChannelTemplates(dispatch, user.OrganizationID)
                    }).catch(err => {
                        setToast(err.response.data, ToasterType.DANGER)
                        setIsLoading(false)
                        props.CloseTemplate(false)
                    })
            }
        }
    }


    useEffect(() => {
        if (props.SelectedChannel) {
            setChannel(props.SelectedChannel)
        }
        if (props.SelectedPage) {
            setPage(props.SelectedPage)
        } else {
            // setPage(props.Channels.find(x => x.ID === props.Template?.ChannelAccountID))
        }
    }, [])

    useEffect(() => {

        setTemplate({ ...template, Media: { ID: "", Name: "", Url: props.Template?.Url, ContentType: props.Template?.MediaType } })
        if (channel === ChannelType.FACEBOOK) {
            if (props.Template?.TemplateType === "media") {
                setMedia({
                    Url: props.Template?.Payload?.elements[0]?.url, Type: props.Template?.Payload?.elements[0]?.media_type
                })
            }
        }
        else {
            setMedia(props.Template?.Url)

        }
        setTemplateHeader(stringToSlate(props.Template?.Payload?.text))
    }, [props.Template, channel])

    return (
        <>
            {IsMobileDevice ?
                <div className="paper-background o-x-hidden w-fill h-v-100">
                    <Grid item xs={12}>
                        <div className='box-shadow-display-background-shadow d-flex align-center p-2'>
                            {IsMobileDevice && <span><BackMobileIcon className={"c-pointer pr-2"} onClick={() => props.CloseTemplate(false)} /></span>}
                            <div>
                                <span className={"h3-semibold color-send-msg-title"}>{!!props.Template?.ID ? DialogHeaders.EDIT_TEMPLATE + " for " : DialogHeaders.ADD_TEMPLATE + " for "}</span>
                                <span className='h3-semibold color-primary-light ml-1'>{page?.Label}</span>
                                <span className='h3-semibold color-send-msg-title ml-1'>{channel === ChannelType.LIVE_CHAT ? "live chat" : channel === ChannelType.FACEBOOK ? "facebook" : "whatsapp"}</span>
                            </div>
                        </div>
                    </Grid>
                    <div className="p-2 mt-2">
                        <TextField
                            className="mt-1"
                            name="Title"
                            placeholder="Template Title"
                            label="Template Title"
                            variant="outlined"
                            size="small"
                            required
                            fullWidth
                            value={template.Title}
                            onChange={(e) => handleTemplateTitle(e.target.value)
                            }
                            InputProps={{ classes: { input: 'h4-regular color-text-field-font' } }}
                            autoComplete='no'
                        />
                        <FormHelperText className="h6-regular color-primary-danger t-align-right">
                            {errors.Title}
                        </FormHelperText>

                        <div className="mt-4">
                            <MessageComposer
                                HandleClose={() => props.CloseTemplate(false)}
                                Message={template.Message}
                                Media={template.Media}
                                HandleChange={handleMessageChanges}
                                IsAddTemplate={true}
                                Limit={1}
                                IsNewMessage={true}
                            />
                            <FormHelperText className="h5 color-primary-danger t-align-right">
                                {!template.Media?.ID && errors.Message}
                            </FormHelperText>
                        </div>
                        <div className="d-flex flex-direction mt-3">
                            <ButtonComponent OnClick={formSubmit} Type={"submit"} ButtonLabel={buttonLabels.SAVE} ClassName={" "} Variant={!props.Show ? "disabled-btn-small" : "primary-btn-small"} Loading={false} />
                            <ButtonComponent OnClick={() => props.CloseTemplate(false)} ButtonLabel={buttonLabels.CANCEL} ClassName={"mt-3 "} Variant={"secondary-btn-small"} />
                        </div>
                    </div>
                </div>
                :
                <Dialog
                    maxWidth="lg"
                    fullWidth={true}
                    disableEscapeKeyDown
                    BackdropProps={{ style: { backgroundColor: "transparent" } }}
                    open={props.Show}
                    onClose={() => props.CloseTemplate(false)}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    classes={{ paper: `${channel === ChannelType.FACEBOOK ? "w-120 h-p-80" : "w-75"} br-2 dialogue-shadow` }}
                >
                    <DialogTitle id="alert-dialog-title" className="dialog-header">
                        <div className='d-flex align-center'>
                            <span className={"h2-medium color-send-msg-title"}>{!!props.Template?.ID ? DialogHeaders.EDIT_TEMPLATE + " for " : DialogHeaders.ADD_TEMPLATE + " for "}</span>
                            <span className='h2-semibold color-primary-light ml-1'>{page?.Label}</span>
                            <span className='h2-medium color-send-msg-title ml-1'>{channel === ChannelType.LIVE_CHAT ? "live chat" : channel === ChannelType.FACEBOOK ? "facebook" : "whatsapp"}</span>
                            <Tooltip title='Close' placement='bottom-start'>
                                <CancelIcon className={"c-pointer ml-auto"} onClick={() => props.CloseTemplate(false)} />
                            </Tooltip>
                        </div>
                    </DialogTitle>
                    <DialogContent className="o-hidden pb-2">
                        <div className={`${channel === ChannelType.FACEBOOK ? "w-p-100 h-p-100 d-flex justify-between" : ""}`}>
                            <div className={`${channel === ChannelType.FACEBOOK ? "h-p-99 w-p-48 pr-1 o-y-scroll" : ""} `}>
                                {/* <SelectChannelComponent Channel={handleChannel} ChannelType={channel} ClassName={"mt-1"} IsSelectChannelDisable={true} />
                            <FormHelperText className="h6-regular color-primary-danger t-align-right">
                                {errors.Channel}
                            </FormHelperText>
                            {(channel === ChannelType.FACEBOOK || channel === ChannelType.LIVE_CHAT) &&
                                <>
                                    <Autocomplete
                                        disabled={true}
                                        className="mt-2"
                                        value={page}
                                        onChange={handlePage}
                                        options={(Channels.filter(x => x.ChannelType === channel as number) as ChannelAccountModel[])}
                                        getOptionLabel={(page) => (page?.Name || page?.Label)}
                                        classes={{
                                            option: "custom-option",
                                            input: `color-text-field-font h4-regular `
                                        }}
                                        renderInput={(params) =>
                                            <TextField
                                                {...params}
                                                label="Select Page"
                                                required
                                                variant='outlined'
                                                size='small'
                                                InputLabelProps={{
                                                    shrink: true,
                                                }} />}
                                    />
                                    <FormHelperText className="h6-regular color-primary-danger t-align-right">
                                        {errors.Page}
                                    </FormHelperText>
                                </>
                            } */}
                                <TextField
                                    className="mt-1"
                                    name="Title"
                                    placeholder="Template Title"
                                    label="Template Title"
                                    variant="outlined"
                                    size="small"
                                    required
                                    fullWidth
                                    value={template.Title}
                                    onChange={(e) => handleTemplateTitle(e.target.value)
                                    }
                                    InputProps={{ classes: { input: 'h4-regular color-text-field-font' } }}
                                    autoComplete='no'
                                />
                                <FormHelperText className="h6-regular color-primary-danger t-align-right">
                                    {errors.Title}
                                </FormHelperText>
                                {
                                    (channel === ChannelType.LIVE_CHAT || channel === ChannelType.GOOGLE_BUSINESS) &&
                                    <div className="mt-2">
                                        <MessageComposer
                                            HandleClose={() => props.CloseTemplate(false)}
                                            Message={template.Message}
                                            Media={template.Media}
                                            HandleChange={handleMessageChanges}
                                            IsAddTemplate={true}
                                            Limit={1}
                                            IsNewMessage={true}
                                        />
                                        <FormHelperText className="h5 color-primary-danger t-align-right">
                                            {!template.Media?.ID && errors.Message}
                                        </FormHelperText>
                                    </div>
                                }

                                {channel === ChannelType.FACEBOOK &&
                                    <>
                                        <Autocomplete
                                            className="mt-2"
                                            value={templateType}
                                            onChange={handletemplateType}
                                            options={FaceBooktemplateTypes}
                                            disableClearable
                                            getOptionLabel={(template) => template.Name}
                                            classes={{
                                                option: "custom-option",
                                                input: `color-text-field-font h4-regular`
                                            }}
                                            renderInput={(params) =>
                                                <TextField
                                                    {...params}
                                                    inputProps={{ ...params.inputProps, readOnly: true }}
                                                    placeholder="Select Predefined Templates"
                                                    label="Facebook Template"
                                                    // required
                                                    variant='outlined'
                                                    size='small'
                                                    onKeyDown={(e) => { e.preventDefault() }}
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }} />}
                                        />
                                        <FormHelperText className="h6-regular color-primary-danger t-align-right">
                                            {errors.TemplateType}
                                        </FormHelperText>
                                        {!!templateType && (templateType.Value === FacebookTemplateType.MEDIA_TEMPLATE &&
                                            <>
                                                <div className="h4-semibold mx-auto">Select Media From Page</div>
                                                <div className="h4-semibold  w-p-100 d-flex justify-center align-center">
                                                    <ButtonComponent OnClick={() => handleFacebookPhotos()} ButtonLabel={"Select From Facebook"} Variant={"secondary-btn-small"} ClassName="w-p-100 h4-regular" />
                                                </div>
                                            </>
                                        )}
                                        {!!templateType && (templateType.Value === FacebookTemplateType.BUTTON_TEMPLATE &&
                                            <>
                                                <div className="h4-semibold">Write the template header</div>
                                                <RichEditor IsMobileDevice={IsMobileDevice} value={templateHeader} setValue={(value: Node[]) => handleHeader(value)} Whatsapptemplates={true} />
                                                <FormHelperText className="h6-regular color-primary-danger t-align-right">
                                                    {errors.TemplateHeader}
                                                </FormHelperText>
                                                <Autocomplete
                                                    className="mt-1"
                                                    value={buttonType}
                                                    onChange={handleButtonType}
                                                    options={FaceBookButtonTypes}
                                                    getOptionLabel={(button) => button.Name}
                                                    classes={{
                                                        option: "custom-option",
                                                        input: `color-text-field-font h4-regular`
                                                    }}
                                                    renderInput={(params) =>
                                                        <TextField
                                                            {...params}
                                                            label="Button Type"
                                                            required
                                                            variant='outlined'
                                                            size='small'
                                                            inputProps={{ ...params.inputProps, readOnly: true }}
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }} />}
                                                />
                                                <FormHelperText className="h6-regular color-primary-danger t-align-right">
                                                    {errors.ButtonType}
                                                </FormHelperText>
                                            </>)
                                        }
                                        {!!templateType && ((templateType.Value === FacebookTemplateType.BUTTON_TEMPLATE ? !!buttonType : templateType.Value === FacebookTemplateType.MEDIA_TEMPLATE) &&
                                            <>
                                                <div className="h4-semibold mt-1">{`${buttons.length}/${templateType && templateType.Value === FacebookTemplateType.BUTTON_TEMPLATE ? "3" : "1"} buttons added`}</div>
                                                {!!buttons.length &&
                                                    <div className="w-p-100 bg-color-secondary-btn-highlight-hover d-flex flex-direction align-center pt-2">
                                                        <div className="h6-semibold w-p-94 d-flex justify-flex-start">Don't use more than 1-3 words or add punctuations*</div>
                                                        {
                                                            buttons.map(x =>
                                                                <div className={`w-p-94 ${x.ButtonError || x.UrlError ? "h-10" : "h-8"} bg-color-secondary d-flex flex-direction align-center justify-center  mb-2`}>

                                                                    <div className={`d-flex justify-around align-center ${x.ButtonError || x.UrlError ? "mt-2" : ""}`}>
                                                                        <TextField
                                                                            className={`${buttons.length > 1 ? "ml-1" : ""} ${buttons.length === 1 ? "w-p-48" : "w-p-44"}`}
                                                                            placeholder={""}
                                                                            label={`Button`}
                                                                            variant="outlined"
                                                                            size="small"
                                                                            required
                                                                            fullWidth
                                                                            value={x.ButtonName}
                                                                            onChange={(e) => handleButtonName(e.target.value, x.Id)
                                                                            }
                                                                            InputProps={{ classes: { input: 'h4-regular color-text-field-font' } }}
                                                                            autoComplete='no'
                                                                        />
                                                                        <TextField
                                                                            className={`${buttons.length === 1 ? "w-p-48" : "w-p-44"}`}
                                                                            placeholder={""}
                                                                            label={`Url`}
                                                                            variant="outlined"
                                                                            size="small"
                                                                            required
                                                                            fullWidth
                                                                            value={x.Url}
                                                                            onChange={(e) => handleButtonUrl(e.target.value, x.Id)
                                                                            }
                                                                            InputProps={{ classes: { input: 'h4-regular color-text-field-font' } }}
                                                                            autoComplete='no'
                                                                        />
                                                                        {buttons.length > 1 &&
                                                                            < div className="w-p-8 h-p-100 d-flex justify-center align-center">
                                                                                <Tooltip title='Close' placement='bottom-start'>
                                                                                    <CancelIcon className={"c-pointer"} onClick={() => handleRemoveButton(x.Id)} />
                                                                                </Tooltip>
                                                                            </div>
                                                                        }

                                                                    </div>
                                                                    <div className={`w-p-100 d-flex justify-around align-center ${x.UrlError ? "" : ""}`}>
                                                                        <div className={`${buttons.length === 1 ? "w-p-48" : "w-p-44"}`}>
                                                                            {x.ButtonError &&
                                                                                <FormHelperText className={`h6-regular color-primary-danger t-align-right`}>
                                                                                    {x.ButtonError}
                                                                                </FormHelperText>
                                                                            }
                                                                        </div>
                                                                        <div className={`${buttons.length === 1 ? "w-p-48" : "w-p-44"}`}>
                                                                            {x.UrlError &&
                                                                                <FormHelperText className={`h6-regular color-primary-danger t-align-right`}>
                                                                                    {x.UrlError}
                                                                                </FormHelperText>
                                                                            }
                                                                        </div>
                                                                        {buttons.length > 1 &&
                                                                            < div className="w-p-8 h-p-100 d-flex justify-center align-center">
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            )
                                                        }
                                                        {!!templateType && ((templateType.Value === FacebookTemplateType.BUTTON_TEMPLATE ? buttons.length < 3 : buttons.length < 1) &&
                                                            <div onClick={() => handleAddButton()} className="d-flex align-center h4-semibold c-pointer mb-2" >
                                                                <Tooltip title='add Button' placement='bottom-start'>
                                                                    <TemplateAddButtonIcon className="c-pointer" onClick={() => handleAddButton()} />
                                                                </Tooltip>
                                                                <div className="ml-1">Add More</div>
                                                            </div>)
                                                        }
                                                    </div>
                                                }
                                            </>)
                                        }
                                    </>
                                }
                            </div>

                            {channel === ChannelType.FACEBOOK &&
                                <div className={`${channel === ChannelType.FACEBOOK ? "h-p-100 w-p-48 bg-color-channel-template-background" : ""}`}>
                                    <div className="h-p-20 w-p-100 d-flex align-center h4-bold ml-4">
                                        Template Preview
                                    </div>
                                    <div className="h-p-80 w-p-100 d-flex justify-center align-center ">
                                        {!!templateType && (templateType.Value === FacebookTemplateType.BUTTON_TEMPLATE ?
                                            <div className="w-p-70 h-p-50 d-flex flex-direction ">
                                                {!!templateHeader && <div className="w-p-100 min-h-4 max-h-60 o-y-scroll h4-regular d-flex align-center bg-color-channel-button-template-header-background brt-1 channel-template-preview-box-shadow p-1">
                                                    {handleTemplateHeaderPreview(templateHeader)}
                                                </div>
                                                }
                                                {buttons.map(x =>
                                                    <div className="brb-1 w-p-100 h5-semibold h-p-20 d-flex justify-center align-center bg-color-secondary channel-template-preview-box-shadow color-template-link h5-regular c-pointer px-1" onClick={() => handleUrlRoute(x.Url, x.ButtonName)}>
                                                        {x.ButtonName}
                                                    </div>
                                                )
                                                }
                                            </div>
                                            :
                                            <div className="w-p-70 h-p-70 d-flex flex-direction">
                                                <div className="w-p-100 h-p-84 bg-color-secondary brt-1 channel-template-preview-box-shadow d-flex justify-center align-center p-relative">
                                                    {
                                                        media?.Type === "video" &&
                                                        <PlayButtonRed className={`p-absolute w-4 h-4 m-auto`} />
                                                    }
                                                    {media?.Url &&
                                                        <img src={media.Url} className="w-p-100 h-p-100 brt-1 d-flex justify-center align-center" />
                                                    }
                                                </div>
                                                <div className={"bb-primary-background-pink-4 mx-auto"}></div>
                                                <div className="brb-1 w-p-100 h-p-16 d-flex justify-center align-center bg-color-secondary channel-template-preview-box-shadow color-template-link h4-regular c-pointer" onClick={() => handleUrlRoute(buttons[0].Url, buttons[0].ButtonName)}>
                                                    {buttons[0].ButtonName}
                                                </div>
                                            </div>)
                                        }
                                    </div>
                                </div>
                            }
                            {openImages &&
                                <Dialog
                                    maxWidth="lg"
                                    fullWidth={true}
                                    disableEscapeKeyDown
                                    BackdropProps={{ style: { backgroundColor: "transparent" } }}
                                    open={props.Show}
                                    onClose={() => props.CloseTemplate(false)}
                                    aria-labelledby="alert-dialog-title"
                                    aria-describedby="alert-dialog-description"
                                    classes={{ paper: `w-40 h-50 br-2 dialogue-shadow` }}
                                >
                                    <DialogTitle>
                                        <div className='d-flex align-center'>
                                        </div>
                                    </DialogTitle>
                                    <DialogContent className="ox-hidden">
                                        <Grid container spacing={1}>
                                            {imageLinks.map((x, index) => (
                                                <Grid item xs={6} key={index} onClick={() => handleImageClick(x)} className={`${x.Url === media.Url ? "overlay" : "template-photo-selector"} c-pointer`}>
                                                    <div className='w-p-100 h-p-100 p-relative'>
                                                        {x.Url === media.Url &&
                                                            <TickIcon className={"p-absolute autocomplete-popper w-3 h-3 b-0 r-0"} />
                                                        }
                                                        {
                                                            x.Type === "video" &&
                                                            <PlayButtonRed className={`p-absolute w-3 h-3 b-3 r-6`} />
                                                        }
                                                        <img
                                                            src={x.Url}
                                                            alt={`Image ${index}`}
                                                            style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: "4px", }}
                                                            className={`${x.Url === media.Url ? "opacity-1" : ""}`}
                                                        />
                                                    </div>
                                                </Grid>
                                            ))}
                                        </Grid>
                                    </DialogContent>
                                    <DialogActions>
                                        <div className="d-flex float-right">
                                            <ButtonComponent OnClick={() => { setOpenImages(false); setImageLinks([]) }} ButtonLabel={buttonLabels.SELECT} ClassName={"ml-auto"} Variant={!media.Url.length ? "disabled-btn-small" : "primary-btn-small"} />
                                            <ButtonComponent OnClick={() => { setOpenImages(false); setImageLinks([]); setMedia({ Type: "", Url: "" }); }} ButtonLabel={buttonLabels.CANCEL} ClassName={"mr-2 ml-2"} Variant={"secondary-btn-small"} />
                                        </div>
                                    </DialogActions>
                                </Dialog>
                            }
                        </div>
                    </DialogContent>
                    <DialogActions className="py-0">
                        <div className="d-flex float-right pr-1 pb-2">
                            <ButtonComponent OnClick={formSubmit} Type={"submit"} ButtonLabel={buttonLabels.SAVE} ClassName={"px-4 ml-auto"} Variant={!props.Show ? "disabled-btn-small" : "primary-btn-small"} Loading={isLoading} />
                            <ButtonComponent OnClick={() => props.CloseTemplate(false)} ButtonLabel={buttonLabels.CANCEL} ClassName={"mr-1 ml-2"} Variant={"secondary-btn-small"} />
                        </div>
                    </DialogActions>
                </Dialog >
            }
        </>
    )
}



export default AddTemplateComponent;